/** @jsx jsx */
import { jsx, css } from "@emotion/react";
import { LinkBtn } from "./Tween";

const containerCSS = css`
    padding: 0 16px;
    color: #505050;

    .trpr__primary-layout-itinerary-items[data-min-width~="450"] & {
        padding: 0 24px;
    }

    .trpr__primary-layout-itinerary-items[data-min-width~="650"] & {
        padding: 0 32px;
    }
`;
const wrapperCSS = ({ singleLine }) => css`
    padding: 0 16px;
    display: flex;
    align-items: ${singleLine ? "center" : "flex-start"};
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;

    .trpr__primary-layout-itinerary-items[data-min-width~="450"] & {
        padding: 0 24px;
    }
`;
const iconCSS = css`
    color: #707070;
    font-size: 20px;
    height: 20px;
    margin-right: 12px;
    width: 20px;
`;
const contentCSS = ({ hasLink }) => css`
    color: #707070;
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;

    a {
        color: #504cf3;
    }

    ${hasLink &&
        `
        margin-bottom: 10px;
    `}
`;
const linkCSS = css`
    width: 100%;

    .trpr__primary-layout-itinerary-items[data-min-width~="450"] & {
        width: auto;
    }
`;

function GenericTween(props) {
    const { iconLabel, icon, singleLine, className, children, link } = props;

    const iconEl = icon.includes("https://") ? (
        <object css={iconCSS} type="image/svg+xml" data={icon}>
            {iconLabel}
        </object>
    ) : (
        <i css={iconCSS} className={`trpr__icon-${icon}`} />
    );
    const hasLink = typeof link === "string" || typeof link?.url === "string";

    return (
        <div css={containerCSS} className={className}>
            <div css={wrapperCSS({ singleLine })}>
                {iconEl}
                <div>
                    <div css={contentCSS({ hasLink })}>{children}</div>
                    <LinkBtn css={linkCSS} link={link}></LinkBtn>
                </div>
            </div>
        </div>
    );
}

export default GenericTween;
